// app/plugins/1-prefetch-settings.ts
import { watch } from 'vue'

export default defineNuxtPlugin(async () => {
    const settingsStore = useSettingsStore();
    const menusStore = useMenusStore();
    const nuxtApp = useNuxtApp();
    if (import.meta.client) {
        watch(() => nuxtApp.$i18n.locale.value, () => {
            void nuxtApp.runWithContext(() => settingsStore.load())
                .catch((error) => console.error('Settings reload failed:', error))
        })
    }
    try {
        await Promise.all([
            settingsStore.load(),
            menusStore.load(),
        ])
    } catch (e) {
        console.error('Settings prefetch failed:', e)
    }
})
